<script setup>
// @ts-check

import { getCurrentInstance, onUnmounted, ref, watch } from 'vue'

defineProps({
  label: {
    type: String,
    required: true
  }
})

const emit = defineEmits(['toggle'])

defineOptions({
  name: 'BottomNavDropdownButton'
})

const isOpen = ref(false)
const instance = getCurrentInstance()

/**
 * @param {MouseEvent} event
 */
const onClickOutside = (event) => {
  if (instance?.vnode.el && !instance.vnode.el.contains(event.target)) {
    isOpen.value = false
  }
}

const toggleDropdown = () => {
  isOpen.value = !isOpen.value
}

watch(isOpen, (open) => {
  if (open) {
    document.addEventListener('click', onClickOutside)
  } else {
    document.removeEventListener('click', onClickOutside)
  }
  emit('toggle', open)
})

onUnmounted(() => {
  document.removeEventListener('click', onClickOutside)
})
</script>

<template>
  <div class="bottom-nav_toggle-btn">
    <span class="bottom-nav_toggle-btn-icon-spacer"></span>
    <span
      id="bottom-nav_toggle-btn-label"
      class="bottom-nav_toggle-btn-label"
      >{{ label }}</span
    >
    <button
      aria-labelledby="bottom-nav_toggle-btn-label"
      type="button"
      class="bottom-nav_toggle-btn-btn"
      @click.stop="toggleDropdown"
    >
      <VIcon :icon="isOpen ? '$minus' : '$plus'" size="1.5rem" />
    </button>
  </div>
</template>
